import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './marquee-item.module.scss'
import { Markdown } from '@components/markdown'
import type { MarqueeItemFragment } from '@graphql/fragments/MarqueeFragment.graphql'

export const MarqueeItem: FunctionComponent<Props> = ({
    image,
    copy,
    size = 'default',
}) => {
    if (!image?.source) {
        return null
    }

    return (
        <div
            className={classNames(
                styles.card,
                size === 'large' && styles.large,
            )}
        >
            <img
                className={styles['card-image']}
                src={image.source}
                alt={image.alt ?? ''}
            />
            <Markdown
                markdown={copy}
                typeStyle='body-xs'
                color='dim'
                boldColor='primary'
            />
        </div>
    )
}

export default MarqueeItem

interface Props extends Omit<MarqueeItemFragment, 'sys' | 'type'> {
    size: string
}
